module.exports = __webpack_public_path__ + "static/media/User_Icon_1.3ddfc98f.svg";